// extracted by mini-css-extract-plugin
module.exports = {"fadeScrollWrapper":"scroll-container_fadeScrollWrapper__WgppL","fadeScrollContent":"scroll-container_fadeScrollContent__qoA0u","hide":"scroll-container_hide__Xth6e"};